import React, { ReactNode } from 'react';
import styled from 'styled-components';
import DialogTitle from './DialogTitle';
import DialogContent from './DialogContent';
import DialogActions from './DialogActions';

interface DialogProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  style?: React.CSSProperties;
}

/**
 * @param {boolean} isOpen - 다이얼로그 열림 여부
 * @param {() => void} onClose - 다이얼로그 닫기 함수
 * @param {React.ReactNode} children - 다이얼로그 내용
 * @param {React.CSSProperties} style - 다이얼로그 스타일
 *
 */
const Dialog: React.FC<DialogProps> = ({ isOpen, onClose, children, style }) => {
  if (!isOpen) return null;

  return (
    <Backdrop onClick={onClose}>
      <Contents onClick={(e) => e.stopPropagation()} style={style}>
        {children}
      </Contents>
    </Backdrop>
  );
};

export { Dialog, DialogTitle, DialogContent, DialogActions };

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Contents = styled.div`
  background-color: #fff;
  border-radius: 8px;
  width: 520px;
  max-width: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;
